import AboutCoach from './AboutCoach'
export default AboutCoach
